/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       LeftArrowImage.tsx
 * @author     Christian Ascone
 * @date       9/24/19 12:57 PM
 */

import React from 'react';
import {Image} from "react-native";
import {imageUri} from "../../models/ImageUri";

export function LeftArrowImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                imageUri.left_arrow.uri
            }
        />
    );
}